<template>
  <NpsForm :default-form="defaultForm" :submit-form="updateNps" :loading="loading" :getting="getting" :title="$t('events.nps.update')" @load="loadNps" :show="true"/>
</template>

<script setup>
import {computed, onMounted, ref, watch} from "vue";
import {useStore} from "vuex";
import {useRouter, useRoute} from "vue-router";
import NpsForm from "../../components/NpsForm.vue";

const route = useRoute()
const router = useRouter()

const store = useStore()

const getting = ref(false)
const loading = ref(false)
const defaultForm = ref({})

const company = computed(() => store.getters['offices/getSelectedCompany'])

watch(() => route.params.nps, () => {
  if(route.params.nps){
    loadNps()
  }
})

watch(() => route.query.tab, (value) => {
  if(value == 'tab-nps') {
    loadFieldTypes()
    store.dispatch('mail/loadMailMessage')
    if(route.params.nps){
      loadNps()
    }
  }
})

const loadNps= () => {
  getting.value = true
  store.dispatch('eventNps/getNps', route.params.nps).then((resp) => {
    initForm(resp.data.data)
  })
  .finally(() => getting.value = false)
}


function updateNps({data, submit}){  
  loading.value = true
  store.dispatch('eventNps/updateNps', {...data, society_id: company?.value.id, name: data?.title, event_id: route.params.id})
      .then(res => {
        window.toastr['success'](i18n.global.t("notification.nps_updated"))
        if(submit){
          router.push({ name: 'events-nps-index', params: { id: route.params.id }, query: { tab: route.query.tab || 'tab-nps' } })
        }
      })
      .catch((err) => {
      })
      .finally(() => loading.value = false)
}

const loadFieldTypes = () => {
  store.dispatch('nps/getFieldTypes')
}

function initForm(nps){
  let data = []
  nps?.form?.fields?.forEach(field => {
      data.push({
        type: field.type || 'text',
        label: field.label || '',
        name: field.name || '',
        placeholder: field.placeholder || '',
        required: field.required || false,
        options: field.options || [],
        extensions: field.extensions || [],
        repeatable: field.repeatable || false,
        can_delete: field.can_delete
      })
  });

  defaultForm.value =  {
    id:nps?.id,
    title:nps?.title,
    name:nps?.title,
    nps_description:nps?.nps_description,
    icon:nps?.icon,
    society_id:nps?.form?.society?.id,
    min_value: 1,
    max_value:10,
    fields: data,
    participator_type: nps?.participator_type?.value,
    all_type: nps?.all_type,
    sent: nps?.sent
  }
}

onMounted(() => {
  if(route.query.tab == 'tab-nps'){
    loadFieldTypes()
    store.dispatch('mail/loadMailMessage')
    if(route.params.nps){
      loadNps()
    }
  }
})
</script>

<style scoped>
.password-input {
  position: relative;
}

.toggle-password {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}

#eye-icon {
  font-size: 1.2em;
}
</style>
